
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'

// module components
import BidsTabs from '@/modules/BidsModule/components/BidsTabs/index.vue'
import BidsChangeFtlStatusForm from '@/modules/BidsModule/components/BidsChangeFtlStatusForm/index.vue'

// composable
import { createToast } from 'mosha-vue-toastify'
import { useRoute } from 'vue-router'

// types
import { BidT } from '@/core/types/bids.types'

// realisations
import { bids } from '@/core/realisations/bids.realisation'
import useAccount from '@/common/composable/useAccount'

import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export const DetailsColumns = [
    {
        name: 'Имя',
        key: 'name',
    },
    {
        name: 'Должность',
        key: 'role',
    },
    {
        name: 'Запрашиваемая стоимость',
        key: 'costOfTransportation',
    },
    {
        name: 'Ответ',
        key: 'status',
    },
    {
        name: 'Комментарий',
        key: 'comment',
    },
]

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        FailedFetch,
        Loader,
        BidsTabs,
        Cheap,
        BidsChangeFtlStatusForm,
        TheTable,
        TableScrollWrapper,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            bid: null as BidT | null,
            currentTab: 'general',
            //
            is_status_changing: false,
            is_accept_status: false,
            is_decline_status: false,
        })

        const route = useRoute()
        const id = Number(route.params.id)
        const account = useAccount()

        const loadBid = async () => {
            try {
                state.is_loading = true

                const response = await bids.getBid(id)
                state.bid = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true

                createToast(
                    {
                        title: 'При получении заявки произошла ошибка',
                        description: 'Попробуйте ещё раз',
                    },
                    { type: 'danger' }
                )
            } finally {
                state.is_loading = false
            }
        }

        //

        const isGeneral = computed(() => state.currentTab === 'general')
        const isCargo = computed(() => state.currentTab === 'cargo')
        const isCourier = computed(() => state.currentTab === 'courier')
        const isConfirmShowed = computed(() => state.bid && state.bid.status.id === 62)

        const isCanConfirmOrCancel = computed(() => {
            if (!state.bid) return false

            if (isConfirmShowed.value) {
                if (account.havePermission('all-root-permission')) {
                    return true
                }

                if (account.havePermission('bid-cost-check')) {
                    if (state.bid.confirmedDetails.headOfTransport?.isConfirmed) {
                        if (state.bid.confirmedDetails.isNeedSecondConfirmation) {
                            if (
                                state.bid.confirmedDetails.headOfOperation &&
                                state.bid.confirmedDetails.headOfOperation.id ===
                                    account.state.user_id
                            ) {
                                return true
                            }
                        }
                    } else {
                        if (
                            state.bid.confirmedDetails.headOfTransport.id === account.state.user_id
                        ) {
                            return true
                        }
                    }
                }
            }

            return false
        })

        const isConfirmedByHeadOfTransport = computed(() => {
            if (state.bid && state.bid.status.id === 62) {
                return state.bid.confirmedDetails.headOfTransport?.isConfirmed
            }

            return false
        })

        const headOfTransportConfirmationText = computed(() => {
            if (isConfirmedByHeadOfTransport.value) {
                return 'Подтверждено Руководителем Транспортного Отдела'
            }

            return 'Необходимо подтверждение Руководителя Транспортного отдела'
        })

        const onAccepted = () => {
            state.is_accept_status = true
            state.is_status_changing = true
        }

        const onDeclined = () => {
            state.is_decline_status = true
            state.is_status_changing = true
        }

        const onCancelStatusChange = () => {
            state.is_status_changing = false
            state.is_accept_status = false
            state.is_decline_status = false
        }

        const onStatusChanged = () => {
            onCancelStatusChange()
            loadBid()
        }

        onBeforeMount(loadBid)

        //

        return {
            state,
            //
            loadBid,
            onAccepted,
            onDeclined,
            onCancelStatusChange,
            onStatusChanged,
            //
            isGeneral,
            isCargo,
            isCourier,
            isConfirmShowed,
            isCanConfirmOrCancel,
            headOfTransportConfirmationText,
            isConfirmedByHeadOfTransport,
            //
            DetailsColumns,
            formatDateWithTimeFromBackend,
            formatDateFromBackend
        }
    },
})
